'use client';

import { useSyncExternalStore } from 'react';
import Link from 'next/link';

function subscribe(callback: () => void) {
  window.addEventListener('storage', callback);
  window.addEventListener('cookie-consent-changed', callback);
  return () => {
    window.removeEventListener('storage', callback);
    window.removeEventListener('cookie-consent-changed', callback);
  };
}
let dismissed = false;
function getVisible() {
  if (dismissed) return false;
  try { return !localStorage.getItem('cookie-consent'); }
  catch { return true; }
}

export default function CookieConsent() {
  const visible = useSyncExternalStore(subscribe, getVisible, () => false);

  const accept = () => {
    dismissed = true;
    try { localStorage.setItem('cookie-consent', 'accepted'); } catch { /* Storage may be disabled. */ }
    window.dispatchEvent(new Event('cookie-consent-changed'));
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-stone p-4 shadow-lg">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center gap-3 sm:gap-4">
        <p className="text-sm text-text-body text-center sm:text-left">
          We use essential cookies to keep you signed in and make the site work. No tracking or advertising cookies.{' '}
          <Link href="/privacy#cookies" className="underline text-forest hover:text-forest-light">
            Read our cookie policy
          </Link>
        </p>
        <button
          onClick={accept}
          className="min-h-11 shrink-0 bg-forest text-white px-5 py-2 rounded-sm text-sm font-medium hover:bg-forest-light transition-colors"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
